function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-10,.cls-11,.cls-13,.cls-2,.cls-9{fill:none;}.cls-2{stroke:#e5e5e5;}.cls-11,.cls-13,.cls-2,.cls-9{stroke-linecap:round;stroke-linejoin:round;}.cls-11,.cls-2{stroke-width:3.06px;}.cls-15,.cls-3{fill:#777;}.cls-12,.cls-3,.cls-4,.cls-5,.cls-6{fill-rule:evenodd;}.cls-14,.cls-4{fill:#c2c2c2;}.cls-5{fill:#383838;}.cls-6{fill:#ed8936;}.cls-7{fill:#fefddb;}.cls-12,.cls-8{fill:#8ce08c;}.cls-9{stroke:#2b7c63;stroke-width:4.49px;}.cls-10{stroke:#ed8936;stroke-miterlimit:10;stroke-width:2.96px;}.cls-11{stroke:#909090;}.cls-13{stroke:#9ef5ee;stroke-width:5.14px;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "watermelon-pack-illustration-15");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "vector"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M509,190.09c58.09,45.72,121.72,87.8,135.7,142.11s-22,121.28-60.43,185.34-79.64,125.36-139,155.35c-59.55,29.85-137.3,28.54-193.06-4.36S162.72,571,125.88,507.93c-36.69-63-76.73-124.48-74.4-185.49C54,261.29,99,200.87,155.15,154.71c56-46.15,123.46-78,183.45-69C398.44,94.58,450.86,144.23,509,190.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M1.53,248.85c0-129,104.57-233.57,233.57-233.57S468.67,119.86,468.67,248.85,364.1,482.42,235.1,482.42,1.53,377.85,1.53,248.85Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M562.1,694.29l19-48.46c-41.12-16.68-95.49-36.61-101.2-41.1-9.12-7.17-53.73-116.91-73.58-160.88-5.5-12.17-80.46,82.72-80.46,82.72C335.67,550,384.55,636.64,402,649.34S561.91,694.16,562.1,694.29Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M297.61,765.87c.26.14,33.92-32.27,33.92-32.27C306.38,695,260,639.87,255.88,635.11c26.65-53.91,130.47-160.47,136.53-172.66s-138.08-31.91-138.08-31.91C242.87,445.5,139.7,600.1,139.7,633.87,139.7,671.36,269.85,750.72,297.61,765.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M250.36,422.77a81.6,81.6,0,1,1,81.6,81.6A81.6,81.6,0,0,1,250.36,422.77Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-6",
  points: "336.35 128.81 221.51 425.82 436.75 425.82 336.35 128.81"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M310,184.36c-47.35,0-156.4-5.66-231.4-28.34V374.38c75,22.67,184.05,28.34,231.4,28.34s156.4-5.67,231.4-28.34V156C466.37,178.7,357.32,184.36,310,184.36Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-8",
  cx: 328.26,
  cy: 53.32,
  r: 49.76
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M301.92,2.24a93.06,93.06,0,0,0,83.49,64.33"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M293.88,44.22c-.68-5.09.69-9.48,3.06-9.8s4.84,3.56,5.52,8.65-.68,9.47-3,9.79S294.57,49.31,293.88,44.22Z"
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-10",
  cx: 406.36,
  cy: 292.05,
  r: 43.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "cls-11",
  cx: 456.75,
  cy: 254.93,
  r: 43.2
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M44.25,220a34.32,34.32,0,1,1,34.32,34.32A34.32,34.32,0,0,1,44.25,220Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-12",
  d: "M516.39,199.57a34.32,34.32,0,1,1,34.31,34.32A34.32,34.32,0,0,1,516.39,199.57Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M139.46,224c19.43,1.88,9.59,103.41,29,105.29s29.26-99.64,48.68-97.76,9.59,103.41,29,105.29,29.26-99.65,48.69-97.76,9.59,103.4,29,105.28"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-14",
  d: "M303.81,757.92c-12.8,11.23-43.32,40.82-33.51,92.47l92.5-81.14L331.53,733.6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-15",
  d: "M565.55,679.31c-6.16,15.88-19.54,56.23,13,97.49l44.5-114.72-44.21-17.15Z"
})));

var SvgWatermelonPackIllustration15 = function SvgWatermelonPackIllustration15(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 647.72 850.39",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWatermelonPackIllustration15, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/watermelon-pack-illustration-15.848c5721.svg";
export { ForwardRef as ReactComponent };